module.exports = __webpack_public_path__ + "img/talent-search-title.df1a4a13.png";